import { Box, CircularProgress } from "@mui/material";

export default function RouteFallback() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="240px"
      width="100%"
    >
      <CircularProgress size={32} />
    </Box>
  );
}
